import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Caveat\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-caveat\"}],\"variableName\":\"caveat\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Source_Serif_4\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-blog\",\"weight\":[\"200\",\"600\",\"700\",\"400\",\"300\",\"500\",\"800\"]}],\"variableName\":\"blog\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Outfit\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\"],\"variable\":\"--font-outfit\"}],\"variableName\":\"outfit\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextAuthProvider"] */ "/vercel/path0/src/providers/NextAuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/providers/tanstackProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/src/providers/ThemeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/performance.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/brand.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/styles/scroll-handler.tsx");
